// * Bootstrap libraries
import "./_bootstrap";
import { tabUnderline, tabLinksAnchor, tabLinksMobile } from "./tab_links";
import "./tab";
import { stickyMenu, megaMenu, toggleMenu, rootMenu, mobileMenu, businessLogoLink } from "./menus";
import { readMoreModal, sliceContent } from "./modal";
// import { TableColResizer } from "./tableResizer";
import { floatingButton } from "./floating_buttons";
import { splideSliders } from "./sliders";
import { sliceExcerpt } from "./excerpts";
import { footerMenuAccordion } from "./footer";
import { select2JS } from "./select2";

// * Any other global site-wide JavaScript should be placed here.

jQuery(document).ready(function ($) {
  stickyMenu($);
  megaMenu($);
  toggleMenu($);
  floatingButton($);
  select2JS($);
  tabUnderline($);
  tabLinksAnchor($);
  tabLinksMobile($);
  splideSliders();
  rootMenu($);
  mobileMenu($);
  // TableColResizer($);
  readMoreModal($);
  sliceContent($);
  sliceExcerpt($);
  businessLogoLink($);
  footerMenuAccordion($);
});
